import create from 'zustand'

const useZusStore = create((set) => ({
  total: 1,
  layouts: 1,
  setTotal: (total) => set({ total }, false),
}))

export default useZusStore
